import { render, staticRenderFns } from "./MediationFooter.vue?vue&type=template&id=f813c4d6&scoped=true&"
import script from "./MediationFooter.vue?vue&type=script&lang=js&"
export * from "./MediationFooter.vue?vue&type=script&lang=js&"
import style0 from "./MediationFooter.vue?vue&type=style&index=0&id=f813c4d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f813c4d6",
  null
  
)

export default component.exports